export class SettingRoutingConstants {
    static SETTINGS_ROUTE = "settings";
    static ATTACHMENTS_ROUTE = "Attachments";
    static ATTACHMENTS_TYPES_ROUTE = "Attachment types";
    static AVAILABLE_SURVEY_123S_ROUTE = "Available survey123s";
    static LOOKUPS_ROUTE = "Lookups";
    static MAP_CONFIG_ROUTE = "Map configuration";
    static NON_WORKING_DAYS_ROUTE = "Non-working days";
    static ORGANISATION_ROUTE = "Organisation";
    static RECIPIENTS_ROUTE = "Recipients";
    static REPORTS_ROUTE = "Reports";
    static STEP_META_DATA_ROUTE = "Step metadata";
    static TARIFFS_ROUTE = "Tariffs";
    static TEMPLATES_ROUTE = "Templates";
    static INVOICE_TEMPLATES_ROUTE = "Invoice templates";
    static RECIPIENT_GROUPS_ROUTE = "Recipient groups";
    static STAMPS = "Stamps";
    static MODULE_ROLES_ROUTE = "Module roles";
    static AFLA_PORTAL_DOCUMENTS_ROUTE = "AFLA portal documents";
    static SEARCH_OPTIONS_ROUTE = "Search options";
    static BACKUP_RESTORE_ROUTE = "Backup Restore";
    static ARCGIS_ROUTE = "ArcGIS items";
    static AFLA_PORTAL_MESSAGE_AND_PAGES_ROUTE = "AFLA portal messages and pages";
    static APPLICATION_WORKFLOW_UPGRADE_ROUTE = "Application workflow upgrade";
    static Test = "Test";
}
